import { ArrowLeft, Calendar, Clock, User, Bot } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "react-router-dom";
import Footer from "@/components/Footer";
import BlogPostImage from "@/components/BlogPostImage";

const BlogPost8 = () => {
  return (
    <div className="min-h-screen bg-background relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-64 h-64 bg-primary/20 rounded-full blur-3xl animate-float" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent/20 rounded-full blur-3xl animate-float" style={{ animationDelay: '2s' }} />
      </div>
      <div className="absolute inset-0 bg-[linear-gradient(to_right,hsl(var(--border)/0.3)_1px,transparent_1px)] bg-[size:8rem_100%] pointer-events-none" style={{ maskImage: 'radial-gradient(ellipse 80% 50% at 50% 0%, black 70%, transparent 110%), linear-gradient(to bottom, black 0%, black 85%, transparent 100%)', maskComposite: 'intersect', WebkitMaskImage: 'radial-gradient(ellipse 80% 50% at 50% 0%, black 70%, transparent 110%), linear-gradient(to bottom, black 0%, black 85%, transparent 100%)', WebkitMaskComposite: 'source-in' }} />

      <header className="border-b border-border/50 bg-card/30 backdrop-blur-xl sticky top-0 z-50 relative">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/"><img src="/logo.png" alt="Coddar Logo" className="h-11 w-auto" /></Link>
          <nav className="hidden md:flex gap-6">
            <Link to="/#servicos" className="text-muted-foreground hover:text-primary transition-colors">Serviços</Link>
            <Link to="/blog" className="text-primary transition-colors">Blog</Link>
            <Link to="/seguranca-digital" className="text-muted-foreground hover:text-primary transition-colors">Segurança Digital</Link>
            <Link to="/contato" className="text-muted-foreground hover:text-primary transition-colors">Contato</Link>
          </nav>
          <Button asChild variant="outline" className="border-primary/50 text-primary hover:bg-primary/10 hover:border-primary">
            <a href="https://folio.app.br/area-cliente">Área do Cliente</a>
          </Button>
        </div>
      </header>

      <article className="py-12 md:py-20 px-4 relative">
        <div className="container mx-auto max-w-4xl relative z-10">
          <Button asChild variant="ghost" className="mb-8 gap-2 hover:gap-3 transition-all">
            <Link to="/blog"><ArrowLeft className="h-4 w-4" /> Voltar ao Blog</Link>
          </Button>

          <Card className="border-border/50 bg-card/50 backdrop-blur-sm p-8 md:p-12">
            <div className="aspect-video w-full rounded-lg mb-8 overflow-hidden">
              <BlogPostImage
                title="Agentes de IA Autônomos: O Futuro da Automação"
                backgroundImage="/assets/blog-Agentes-IA-Autônomos-Futuro-da-Automacao.webp"
                icon={<Bot className="w-full h-full" />}
              />
            </div>

            <div className="flex flex-wrap gap-4 text-sm text-muted-foreground mb-6">
              <div className="flex items-center gap-2"><Calendar className="h-4 w-4" /><span>27 de Outubro, 2025</span></div>
              <div className="flex items-center gap-2"><Clock className="h-4 w-4" /><span>11 min de leitura</span></div>
              <div className="flex items-center gap-2"><User className="h-4 w-4" /><span>Equipe Coddar</span></div>
            </div>

            <h1 className="text-3xl md:text-5xl font-bold text-foreground mb-6">Agentes de IA Autônomos: O Futuro da Automação</h1>

            <div className="prose prose-invert max-w-none">
              <p className="text-lg text-muted-foreground mb-6">
                Agentes de IA autônomos representam a próxima evolução da inteligência artificial: sistemas capazes de tomar decisões, executar tarefas complexas e aprender continuamente sem intervenção humana constante.
              </p>

              <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">O Que São Agentes de IA?</h2>
              <p className="text-muted-foreground mb-4">
                Diferente de chatbots simples, agentes de IA podem planejar, executar múltiplas etapas, usar ferramentas e adaptar estratégias baseadas em resultados.
              </p>

              <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Capacidades dos Agentes</h2>
              <ul className="list-disc list-inside text-muted-foreground mb-6 space-y-2">
                <li>Planejamento de tarefas complexas</li>
                <li>Uso de ferramentas e APIs</li>
                <li>Tomada de decisões contextuais</li>
                <li>Aprendizado com feedback</li>
                <li>Execução autônoma de workflows</li>
              </ul>

              <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Casos de Uso</h2>
              <p className="text-muted-foreground mb-4">
                Agentes de IA já estão sendo usados em atendimento ao cliente, análise de dados, automação de processos empresariais e muito mais.
              </p>

              <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">O Futuro</h2>
              <p className="text-muted-foreground mb-4">
                Nos próximos anos, agentes de IA se tornarão cada vez mais sofisticados, capazes de gerenciar operações empresariais inteiras com mínima supervisão humana.
              </p>

              <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Conclusão</h2>
              <p className="text-muted-foreground">
                Agentes de IA autônomos não são ficção científica - são realidade atual que está transformando a forma como empresas operam e competem.
              </p>
            </div>

            <div className="mt-12 p-6 bg-primary/10 border border-primary/20 rounded-lg">
              <h3 className="text-xl font-bold text-foreground mb-2">Implemente Agentes de IA</h3>
              <p className="text-muted-foreground mb-4">Descubra como agentes autônomos podem revolucionar seus processos.</p>
              <Button asChild><Link to="/contato">Fale Conosco</Link></Button>
            </div>
          </Card>
        </div>
      </article>
      <Footer />
    </div>
  );
};

export default BlogPost8;
